module.exports = __webpack_public_path__ + "static/media/setpoint-czuwanie.a44bf7df.svg";